import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { BAR_STYLES } from './helpers/constants';
import KeyDatesHeaderWidget from 'routes/BudgetModule/components/shared/BudgetHeader/KeyDatesHeaderWidget';

const StyHeader = styled(Box, {
    name: 'StyHeader',
})({
    top: 0,
    width: '100%',
    boxShadow: '4px 8px 24px rgba(0, 0, 0, 0.06)',
    height: '5em',
    ...BAR_STYLES,
    // we override the value from BAR_STYLES
    padding: '0 0 0 2rem',
});

type Props = {
    exercice: number;
    operationName: string;
};

export default function OperationHeader({
    exercice,
    operationName,
}: Props): React.ReactElement {
    return (
        <StyHeader>
            <Typography variant="h4" color="primary">
                {operationName}
            </Typography>
            <KeyDatesHeaderWidget exercice={exercice} />
        </StyHeader>
    );
}
